<template>
  <div class="transfer-referrals">
    <div v-if="!isLoading" class="container">
      <div class="transfer__title">Ручная привязка рефералов</div>
      <div class="transfer-referrals__row">
        <div class="transfer-referrals__row-item">
          <div class="transfer-referrals-radio-wrap">
            <label class="settings-choice-item">
              <input type="radio" v-model="linkReferral" :value="true" />
              <span>Привязать реферала</span>
            </label>
            <label class="settings-choice-item">
              <input type="radio" v-model="linkReferral" :value="false" />
              <span>Отвязать реферала</span>
            </label>
          </div>
        </div>
      </div>

      <div class="transfer-referrals-wrap">
        <div class="dropdown-wrap">
          <div class="dropdown-title">Пользователь-агент</div>
          <SingleSelector :options="formattedAgents" @handleChange="setUserAgent" />
        </div>

        <div v-if="linkReferral" class="dropdown-wrap" :class="{ disabled: !selectedUserAgent }">
          <div class="dropdown-title">Реферальная ссылка агента</div>
          <SingleSelector
            :key="`user-agent-selector-${forceRerenderKey}`"
            :options="formattedAgentListLinks"
            @handleChange="setAgentReferralLink"
          />
        </div>

        <div v-if="linkReferral" class="dropdown-wrap">
          <div class="dropdown-title">Доступные для привязки пользователи</div>
          <SingleSelector
            :key="`users-selector-${forceRerenderKey}`"
            :options="formattedNoReferralUsers"
            @handleChange="setUseForTransfer"
          />
        </div>

        <div v-if="!linkReferral" class="dropdown-wrap" :class="{ disabled: !selectedUserAgent }">
          <div class="dropdown-title">Пользователь-реферал</div>
          <SingleSelector
            key="referrals-selector"
            :options="formattedAgentReferrals"
            @handleChange="setUserReferral"
          />
        </div>
        <div class="transfer-referrals__row">
          <div class="transfer-referrals__row-item">
            <ButtonElement
              :text="linkReferral ? 'Привязать' : 'Отвязать'"
              :disabled="isDisabledBtn"
              @click-button="sendData"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else v-loading="isLoading" class="transfer-referrals__loading-screen"></div>
  </div>
</template>

<script>
import SingleSelector from '@/components/sort/SingleSelector';
import ButtonElement from '@/components/elements/ButtonElement';
import axios from 'axios';
import moment from 'moment';

const apiUrl = process.env.VUE_APP_API_URL;
const DEFAULT_AGENT_LINK = 'DEFAULT_AGENT_LINK';

export default {
  name: 'TransferAccounts',
  components: { SingleSelector, ButtonElement },
  data() {
    return {
      linkReferral: true,
      agents: [],
      noReferralUsers: [],
      agentUsers: [],
      agentListLinks: [],
      // referrals: [],
      selectedUserAgent: null,
      agentReferralLink: null,
      userForTransfer: null,
      userReferral: null,
      isLoading: true,
      forceRerenderKey: 1,
    };
  },
  computed: {
    isDisabledBtn() {
      if (this.linkReferral) {
        return !this.selectedUserAgent || !this.agentReferralLink || !this.userForTransfer;
      } else {
        return !this.selectedUserAgent || !this.userReferral;
      }
    },
    agent() {
      return this.$store.state.Auth.user;
    },
    formattedNoReferralUsers() {
      return this.noReferralUsers
        .filter((item) => {
          if (this.selectedUserAgent) {
            return item.id !== this.selectedUserAgent.id;
          }

          return item;
        })
        .map((item) => ({
          id: item.id,
          name: item.name || item.email,
        }));
    },
    formattedAgents() {
      return this.agents.map((item) => ({
        id: item.id,
        agent_id: item.agent.id,
        name: item.name || item.email,
      }));
    },
    formattedAgentReferrals() {
      return this.agentUsers.map((item) => ({
        id: item.id,
        name: item.name || item.email,
      }));
    },
    formattedReferrals() {
      return this.referrals.map((item) => ({
        id: item.id,
        name: item.name || item.email,
      }));
    },
    formattedAgentListLinks() {
      const standardLink = { id: DEFAULT_AGENT_LINK, name: 'Стандартная реферальная ссылка' };

      if (!this.agentListLinks.length) {
        return [standardLink];
      }

      const customLinks = this.agentListLinks.map((item) => ({
        id: item.id,
        name: item.title,
      }));

      return [standardLink, ...customLinks];
    },
    currentDate() {
      return moment(new Date()).format('YYYY-MM-DD');
    },
  },
  async mounted() {
    await this.loadInitialData();
    this.isLoading = false;
    document.addEventListener('click', this.handleOutsideClick, true);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick, true);
  },
  methods: {
    handleOutsideClick(e) {
      if (!e.target.closest('.selector__content')) {
        this.showOptions = false;
      }
    },
    async loadInitialData() {
      try {
        await Promise.all([
          this.getUsersAgents(),
          this.getNoReferralUsers(),
          // this.getUsersReferrals()
        ]);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      }
    },
    async getUsersAgents() {
      const token = localStorage.getItem('token');

      const resp = await axios.get(`${apiUrl}/admin/users`, {
        params: { per_page: 1000, role: 'agent' },
        headers: { Authorization: `Bearer ${token}` },
      });
      this.agents = resp.data.data;
    },
    // async getUsersReferrals() {
    //   const token = localStorage.getItem('token');

    //   const resp = await axios.get(`${apiUrl}/admin/users`, {
    //     params: { per_page: 1000, role: 'referral' },
    //     headers: { Authorization: `Bearer ${token}` }
    //   });
    //   this.referrals = resp.data.data;
    // },
    async getNoReferralUsers() {
      const token = localStorage.getItem('token');

      const resp = await axios.get(`${apiUrl}/agents/no-referral-users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.noReferralUsers = resp.data.data;
    },
    async getAgentUsers() {
      const token = localStorage.getItem('token');

      const resp = await axios.get(`${apiUrl}/agents/${this.selectedUserAgent.agent_id}/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.agentUsers = resp.data.data;
    },
    async getAgentListLinks() {
      const token = localStorage.getItem('token');

      if (this.selectedUserAgent) {
        const response = await axios.get(
          `${apiUrl}/agents/${this.selectedUserAgent.agent_id}/links`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        this.agentListLinks = response.data.data;
      } else {
        this.agentListLinks = [];
      }
    },
    async sendData() {
      const token = localStorage.getItem('token');

      this.isLoading = true;

      if (this.linkReferral) {
        const data = {
          token: token,
          payload: {
            agent_id: this.selectedUserAgent.agent_id,
            user_id: this.userForTransfer.id,
            ref_link_id:
              this.agentReferralLink.id === DEFAULT_AGENT_LINK ? null : this.agentReferralLink.id,
          },
        };

        try {
          await this.$store.dispatch('Referrals/linkReferralToAgent', data);
          await this.loadInitialData();
          this.$notify({
            message: 'Успешно!',
            type: 'success',
          });
        } catch (e) {
          console.error();
        } finally {
          this.isLoading = false;

          this.selectedUserAgent = null;
          this.agentReferralLink = null;
          this.userForTransfer = null;
          this.userReferral = null;
        }
      } else {
        const data = {
          token: token,
          payload: {
            agent_id: this.selectedUserAgent.agent_id,
            user_id: this.userReferral.id,
          },
        };

        try {
          await this.$store.dispatch('Referrals/unlinkReferralToAgent', data);
          await this.loadInitialData();
          this.$notify({
            message: 'Успешно!',
            type: 'success',
          });
        } catch (e) {
          console.error('Failed,', e);
        } finally {
          this.isLoading = false;

          this.selectedUserAgent = null;
          this.agentReferralLink = null;
          this.userForTransfer = null;
          this.userReferral = null;
        }
      }
    },
    async setUserAgent(arrUserAgent) {
      const [userAgent] = arrUserAgent;

      this.agentReferralLink = null;
      this.userForTransfer = null;
      this.selectedUserAgent = userAgent;

      this.forceRerenderKey += 1;

      await this.getAgentListLinks();
      await this.getAgentUsers();
    },
    setAgentReferralLink(arrAgentReferralLink) {
      const [agentReferralLink] = arrAgentReferralLink;
      this.agentReferralLink = agentReferralLink;
    },
    setUseForTransfer(arrUserForTransfer) {
      const [userForTransfer] = arrUserForTransfer;
      this.userForTransfer = userForTransfer;
    },
    setUserReferral(arrUserReferral) {
      const [userReferral] = arrUserReferral;
      this.userReferral = userReferral;
    },
  },
  watch: {
    linkReferral() {
      this.agentReferralLink = null;
      this.userReferral = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.transfer-referrals-wrap {
  margin-top: 5rem;
  display: flex;
  row-gap: 4rem;
  flex-direction: column;
  max-width: 57.2rem;
}

.transfer-referrals {
  padding: 5rem 0;

  &__loading-screen {
    height: 50dvh;
  }

  &__title {
    font-weight: 700;
    font-size: 3rem;
    line-height: 3.6rem;
    margin-bottom: 3rem;
  }

  &__row {
    display: flex;
    gap: 3.5rem;
  }

  &__row-item {
    width: calc(50% - 3.5rem);
  }

  &__error {
    color: red;
  }
}

.dropdown-wrap {
  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  .selector__content {
    width: 100%;
  }

  .selector__options {
    max-height: 40rem;
    overflow-y: auto;
  }

  .selector__content {
    position: relative;

    .selector__arrow {
      img {
        position: absolute;
        right: 1.5rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.dropdown-title {
  font-family: 'Roboto';
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 1.5rem;
}

.transfer-referrals-radio-wrap {
  display: flex;
  flex-direction: column;
  row-gap: 1.9rem;
}

.settings-choice-item {
  input {
    width: 1.75rem;
    height: 1.75rem;
  }

  span {
    font-size: 2rem;
    margin-left: 1rem;
  }
}

.transfer-referrals__row-item {
  .button {
    min-width: 25rem;
    min-height: 5rem;
  }
}

.form-input.selector__options-search {
  margin-top: 1rem;
}

@media (max-width: 768px) {
  .transfer-referrals__row {
    flex-direction: column;
  }

  .transfer-referrals__row-item {
    width: 100%;
  }

  .dropdown-wrap.calendar {
    .date-picker {
      width: 100%;
      margin: 0 auto;
    }
  }
}
</style>
